module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/js/core/fonts/MaterialIcons-Regular.ttf
// module id = 23
// module chunks = 0